import { Delete } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import { useDialogs } from "@toolpad/core";
import { RemoveUserFromOrganizationDialog } from "../dialogs/RemoveUserFromOrganizationDialog";

interface IProps {
    /**
     * The organization id to remove the user from.
     */
    organizationId: number;
    /**
     * The user id to remove from the organization.
     */
    userId: number;
}

/**
 * A button for removing a user from an organization.
 */
export const RemoveUserFromOrganizationButton = ({
    organizationId,
    userId,
}: IProps) => {
    const dialogs = useDialogs();

    const handleRemove = () => {
        dialogs.open(RemoveUserFromOrganizationDialog, {
            organizationId,
            userId,
        });
    };

    return (
        <GridActionsCellItem
            icon={
                <Tooltip title="Remove User">
                    <Delete />
                </Tooltip>
            }
            label="Remove User"
            onClick={handleRemove}
        />
    );
};
